import React, { useState, useEffect } from "react";
import { Button, TextField, Box, Typography, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { API_AddUser, API_GetUser, API_changepassword } from "./utils/http";
import { AddUser } from "./components/AddUser";
import ListUser from "./components/ListUser";
import { TOKEN_NAME } from "./utils/constDispatch";
import { checkAdminRole, idToTimeDMMMYYYY, showRole } from "./utils/tool";
import AppBarUser from "./components/AppBarBtn";
import { AdminRate } from "./components/AdminRate";

const sxTextField = {
  m: 0.5,
  width: "100%",
  maxWidth: 400,
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    fontSize: 13,
  },
  "& .MuiInputLabel-root": {
    fontSize: 13,
  },
};

export default function User() {
  const navigate = useNavigate();
  const [username, set_username] = useState("");
  const [password, set_password] = useState("");
  const [new_password, set_new_password] = useState("");
  const [new_password_confirmation, set_new_password_confirmation] =
    useState("");

  const [user_arr, set_uer_arr] = useState(null);
  const [status, setStatus] = useState("");

  const canConfirm =
    username !== "" &&
    password !== "" &&
    new_password !== "" &&
    new_password !== password &&
    new_password === new_password_confirmation;

  async function GetUser() {
    API_GetUser((data) => {
      if (data.success) {
        let a = [];

        data.data.map((item) => {
          item.role = showRole(item.role);
          item.date = idToTimeDMMMYYYY(item._id);
          a.push(item);
        });

        set_uer_arr(a);
      }
    });
  }

  const ClickAddUser = (body) => {
    API_AddUser(body, (data) => {
      if (data.success) {
        GetUser();
      }
    });
  };

  useEffect(() => {
    GetUser();
  }, []);

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <AppBarUser
        title="Profile"
        onLogout={() => {
          sessionStorage.removeItem(TOKEN_NAME);
          navigate("/login", { replace: true });
        }}
      />

      <Box sx={{ padding: "20px", display: "flex", flexDirection: "column", gap: 2.5 }}>
        {checkAdminRole() ? (
          <>
            <Paper
              elevation={0}
              sx={{
                border: "1px solid #E0E0E0",
                borderRadius: "10px",
                p: 2.5,
              }}
            >
              <AdminRate />
            </Paper>

            <Paper
              elevation={0}
              sx={{
                border: "1px solid #E0E0E0",
                borderRadius: "10px",
                p: 2.5,
              }}
            >
              <Typography
                sx={{ fontWeight: 600, fontSize: 16, color: "#333", mb: 1.5 }}
              >
                List User
              </Typography>
              {status !== "" && (
                <Typography sx={{ fontSize: 13, color: "#666", mb: 1 }}>
                  {status}
                </Typography>
              )}
              {user_arr != null && (
                <ListUser user_arr={user_arr} get_user={() => GetUser()} />
              )}
            </Paper>

            <Paper
              elevation={0}
              sx={{
                border: "1px solid #E0E0E0",
                borderRadius: "10px",
                p: 2.5,
              }}
            >
              <Typography
                sx={{ fontWeight: 600, fontSize: 16, color: "#333", mb: 1.5 }}
              >
                Add User
              </Typography>
              <AddUser clickAdd={(x) => ClickAddUser(x)} />
            </Paper>
          </>
        ) : null}

        <Paper
          elevation={0}
          sx={{
            border: "1px solid #E0E0E0",
            borderRadius: "10px",
            p: 2.5,
          }}
        >
          <Typography
            sx={{ fontWeight: 600, fontSize: 16, color: "#333", mb: 1.5 }}
          >
            Change Password
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <TextField
              sx={sxTextField}
              size="small"
              id="username"
              label="Username"
              variant="outlined"
              value={username}
              onChange={(e) => set_username(e.target.value)}
            />
            <TextField
              sx={sxTextField}
              size="small"
              id="password"
              type="password"
              label="Old password"
              variant="outlined"
              value={password}
              onChange={(e) => set_password(e.target.value)}
            />
            <TextField
              sx={sxTextField}
              size="small"
              id="new_password"
              type="password"
              label="New password"
              variant="outlined"
              value={new_password}
              onChange={(e) => set_new_password(e.target.value)}
            />
            <TextField
              sx={sxTextField}
              size="small"
              id="new_password_confirmation"
              type="password"
              label="Retype new password"
              variant="outlined"
              value={new_password_confirmation}
              onChange={(e) => set_new_password_confirmation(e.target.value)}
            />
            <Button
              disabled={!canConfirm}
              variant="contained"
              disableElevation
              sx={{
                m: 0.5,
                width: "100%",
                maxWidth: 400,
                borderRadius: "20px",
                textTransform: "none",
                fontWeight: 500,
                fontSize: 13,
                mt: 1,
              }}
              onClick={() => {
                API_changepassword(
                  {
                    username: username,
                    password: password,
                    newpassword: new_password,
                  },
                  (data) => {
                    if (data.success) {
                      sessionStorage.removeItem(TOKEN_NAME);
                      navigate("/login", { replace: true });
                    }
                  }
                );
              }}
            >
              Confirm
            </Button>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
}
